import {Flex, Text, VStack} from 'native-base';
import React from 'react';
import {GestureResponderEvent, Pressable} from 'react-native';
import {t} from 'react-native-tailwindcss';
import {TransactionFieldsFragment} from '../api/generated';
import {useUserContext} from '../lib/authContext';
import {formatIntAmount, formatPhone} from '../lib/formatters';
import moment from '../lib/moment';
import {getStatusStyle} from '../lib/utils';
import {PaymentStatusIcon} from './PaymentStatusIcon';

type Props = {
  item: TransactionFieldsFragment;
  onPress?: (event: GestureResponderEvent) => void;
};

const getTitle = (item: TransactionFieldsFragment, isIncome: boolean) => {
  if (isIncome) {
    return formatPhone(item.fromPhoneNumber) || item.fromAddress;
  }
  return formatPhone(item.toPhoneNumber) || item.toAddress;
};

export const PaymentItem: React.FC<Props> = ({item, onPress}) => {
  const {ethAddress} = useUserContext();
  const isIncome = item.toAddress === ethAddress;
  return (
    <Pressable onPress={onPress}>
      <Flex flex="1" direction="row" key={item.id} style={[t.pY2, t.pX5]}>
        <PaymentStatusIcon
          isIncome={isIncome}
          style={[t.text4xl, t.pT2, getStatusStyle(isIncome)]}
        />
        <Flex
          flex="1"
          direction="row"
          borderBottomWidth="1"
          borderColor="gray.200"
          style={[t.mL4, t.pB4]}
          justifyContent="space-between"
          alignItems="center">
          <VStack flex="1">
            <Text
              bold
              isTruncated
              numberOfLines={1}
              style={[t.textLg, t.textBlack, {minHeight: 22}]}>
              {getTitle(item, isIncome)}
            </Text>
            <Text style={[t.textGray600]}>{moment(item.createdAt, 'x').format('lll')}</Text>
          </VStack>
          <Text style={[t.textXl, t.fontBold, getStatusStyle(isIncome)]}>
            {!isIncome && <>&minus;</>}
            {formatIntAmount(item.amount)}
          </Text>
        </Flex>
      </Flex>
    </Pressable>
  );
};
